export default __webpack_public_path__ + "static/media/coach@3x.9cc92159.webp";